import React, { useState, useEffect, useRef } from 'react';
import {
    Typography,
    Grid,
    Box,
    CssBaseline,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Button,
    Modal,
} from '@mui/material';
import {
Phone,
RemoveRedEye,
Cancel,
EditNote,
DeleteForever,
} from '@mui/icons-material';
import axios from 'axios';
import { global_link } from '../Components/Globallink';
import modalStyle from '../Components/ModalStyle';

const Ticketing = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [formData, setFormData] = useState({});
  const [newticketopen, setNewTicketOpen] = useState(false);
  const [priorityFilter, setPriorityFilter] = useState('');
  const [priorityGroupData, setPriorityGroupData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [ticketCategoryList, setTicketCategoryList] = useState([]);
  const [openAddTicketCategoryListModal, setAddTicketCategoryListModal] = useState(false);

  

  const [newticketeditopen, setNewTickeEditOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);


  const api = axios.create({baseURL: global_link});
  const authToken = process.env.AUTH_TOKEN;

  useEffect(() => {
    fetchData();
    fetchTicketingGroupData();
  }, [searchTerm, priorityFilter, startDate, endDate, page, rowsPerPage]);

  const fetchData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/ticketing/all', {
        params: {
          search: searchTerm,
          priority: priorityFilter,
          start_date: startDate,
          end_date: endDate,
          limit: rowsPerPage,
          offset: page * rowsPerPage,
        },
        headers: {
          Authorization: `Bearer ${authyToken}`,
        },
      });
      setData(response.data.data);
      setTotalItems(response.data.total);
    } catch (error) {
      console.error('Error fetching Ticketing:', error);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRoleFilterChange = (event) => {
    setRoleFilter(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };


  const copyPhoneNumber = (call_from, call_to) => {
    const phoneNumber = call_from.length > 5 ? call_from : call_to;
    const event = new CustomEvent('copyPhoneNumber', { detail: phoneNumber });
    window.dispatchEvent(event);
};
const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };


  const handleNewTicketSubmit = (event) => {
    event.preventDefault();
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    event.preventDefault();
    api.post('/ticketing/add', formData,{ headers, withCredentials: true})
      .then((response) => {
        fetchData();
        setNewTicketOpen(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleNewTicketEditSubmit = (event) => {
    event.preventDefault();
    const authyToken = localStorage.getItem(authToken);
    const headers = {
        Authorization: `Bearer ${authyToken}`,
        "Content-Type": "application/json",
    };
    event.preventDefault();
      const formData = new FormData(event.target);
    api.put('/ticketing/update', formData,{ headers, withCredentials: true})
      .then((response) => {
        fetchData();
        setNewTickeEditOpen(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const getTicketAge = (createdAt,status) => {
    const currentDate = new Date();
    const createdAtDate = new Date(createdAt);
    // Calculate the difference in milliseconds
    const differenceInMilliseconds = currentDate - createdAtDate;
    // Convert milliseconds to seconds
    const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
    if (differenceInSeconds < 60) {
      return `${differenceInSeconds} seconds ago`;
    } else if (differenceInSeconds < 3600) {
        const differenceInMinutes = Math.floor(differenceInSeconds / 60);
        return `${differenceInMinutes} minutes ago`;
    } else if (differenceInSeconds < 86400) {
        const differenceInHours = Math.floor(differenceInSeconds / 3600);
        return `${differenceInHours} hours ago`;
    } else {
      const differenceInDays = Math.floor(differenceInSeconds / 86400);
        return `${differenceInDays} days ago`;
    }
};

const handlePriorityFilterChange = (event) => {
  setPriorityFilter(event.target.value);
};

const fetchTicketingGroupData = async () => {
  try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/ticketing/group', {
          headers: {
              Authorization: `Bearer ${authyToken}`,
          },
      });
      setPriorityGroupData(response.data.data);
  } catch (error) {
      console.error('Error fetching Disposition Group:', error);
  }
};

const handleInputModChange = (event) => {
  const { name, value } = event.target;
  setSelectedItem((prevFormState) => ({
    ...prevFormState,
    [name]: value,
  }));
};


const handleInputModUserChange = (event) => {
  const { name, value } = event.target;
  setSelectedItem(prev => ({
    ...prev,
    [name]: value
  }));
};


const handleOpenEditTicketModal = (item) => {
setSelectedItem(item);
setNewTickeEditOpen(true);
}

const fetchUsersData = async () => {
  try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/user/usersrestrict/', {
          headers: {
              Authorization: `Bearer ${authyToken}`,
          },
      });
      setUsersData(response.data);
  } catch (error) {
      console.error('Error fetching Users:', error);
  }
};

const handleTicketCategoryListSubmit = (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.post('/ticketing/addcategory', formData,{ headers, withCredentials: true})
    .then((response) => {
      fetchTicketCategoryData();
    }).catch((error) => {console.error(error);});
}

const handleCloseAddTicketCategoryListModal = () => {
  setAddTicketCategoryListModal(false);
}

const handleOpenAddTicketCategoryListModal = () => {
  setAddTicketCategoryListModal(true);
}

const fetchTicketCategoryData = async () => {
  try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/ticketing/categorylist', {
          headers: {
              Authorization: `Bearer ${authyToken}`,
          },
      });
      setTicketCategoryList(response.data);
  } catch (error) {
      console.error('Error fetching Disposition Group:', error);
  }
};

const handleTicketCategotyListDelete = async (id) => {
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.delete(`/ticketing/deletecategory/${id}`,{ headers, withCredentials: true})
    .then((response) => {
      fetchTicketCategoryData();
    }).catch((error) => {console.error(error);});
}



useEffect(() => { fetchUsersData(); fetchTicketCategoryData();}, []);

    return (
        <>
            <CssBaseline />
            <Typography variant='h5' sx={{marginBottom:'15px'}}>
            Ticketing
                </Typography>
    <Box sx={{bgcolor:'background.paper',boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px'}}>
      <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
        {/* Search Field */}
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
                    <FormControl variant="outlined" sx={{ width:'60%!important' }}>
                        <InputLabel id="priority-filter-label">Filter by Priority</InputLabel>
                        <Select
                            value={priorityFilter}
                            onChange={handlePriorityFilterChange}
                            label="Filter by Priority"
                            labelId="priority-filter-label"
                        >
                            <MenuItem value="">Select Priority</MenuItem>
                            {priorityGroupData.map((row) => (
                                <MenuItem key={row.priority} value={row.priority}>
                                    {row.priority}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
         <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={handleStartDateChange}
          InputLabelProps={{ shrink: true }}
          sx={{width:'50%!important'}}
        />

        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={handleEndDateChange}
          InputLabelProps={{ shrink: true }}
          sx={{width:'50%!important'}}
        />
                  <Button
    variant="contained"
    sx={{width:'40%!important'}}
    color='primary'
    onClick={() => setNewTicketOpen(true)}

  >
    Add Ticketing
  </Button>
  <Button variant="contained" color="error" sx={{ padding: '10px',}} onClick={handleOpenAddTicketCategoryListModal}>
                        <EditNote sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} />
                      </Button>
      </Box>
            <TableContainer>
        <Table sx={{ fontSize: '5.1rem !important' }} size="small">
          {/* Table Head */}
          <TableHead sx={{bgcolor:'background.table',width:'100%'}}>
            <TableRow>
                <TableCell>Ticket No</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Priority</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Channel</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Assigned</TableCell>
                <TableCell>Age</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
          {data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.id}>
                <TableCell>#{row.id}</TableCell>
                <TableCell>{row.user_name}</TableCell>
                <TableCell>{row.subject}</TableCell>
                <TableCell sx={{ fontWeight:'bold', color: row.priority === 'High' ? 'red' : row.priority === 'Medium' ? 'orange' : row.priority === 'Low' ? 'green' : row.priority === 'Critical' ? 'darkred' :'inherit'}}>
                  {row.priority}
                </TableCell>
                <TableCell sx={{cursor:'pointer'}} onClick={() => copyPhoneNumber(row.phone_number)}>{row.phone_number}</TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.channel}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.assigned_name}</TableCell>
                <TableCell>{getTicketAge(row.created_at,row.status)}</TableCell>
                <TableCell>{row.created_at.slice(0, -5).replace('T', ' ')}</TableCell>
                  <TableCell><Button variant="contained" color="info" sx={{padding:'1px',margin:'5px'}} onClick={() => handleOpenEditTicketModal(row)}><RemoveRedEye sx={{fontSize:'1.5rem', cursor:'pointer', margin:'5px'}}/></Button> </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={13} align="center">
                  No matching records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[10, 50, 100]}
        labelRowsPerPage="Rows per page"
      />



<Modal
        open={newticketopen}
        onClose={() => setNewTicketOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={modalStyle}>
        <div className="modal-content">
            <Box sx={{display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New Ticket</h3>
            <Box display="flex" justifyContent="right">
        <Cancel onClick={() => setNewTicketOpen(false)} sx={{cursor:"pointer"}}/>
        </Box>
            </Box>
          
          <form onSubmit={handleNewTicketSubmit}>
          <Grid container spacing={1}>

<Grid item xs={12}>
<TextField
        fullWidth
        select
        label="Ticket Priority"
        name="priority"
        onChange={handleInputChange}
        required="true"
        sx={{marginTop:"5px"}}
      >
        <MenuItem value="">Select Ticket Priority</MenuItem>
        <MenuItem value="Critical">Critical ( P 1 )</MenuItem>
        <MenuItem value="High">High ( P 2 )</MenuItem>
        <MenuItem value="Medium">Medium ( P 3 )</MenuItem>
        <MenuItem value="Low">Low ( P 4 )</MenuItem>
      </TextField>
</Grid>


          <Grid item xs={6}>
<TextField
              label="Description"
              name="subject"
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required="true"
              sx={{marginTop:"5px"}}
            />
</Grid>


<Grid item xs={6}>
<TextField
              label="Phone Number"
              name="phone_number"
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required="true"
              sx={{marginTop:"5px"}}
            />
</Grid>

<Grid item xs={6}>
<TextField
              label="(Optional) Alternative Phone Number"
              name="alternative_phone_number"
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              sx={{marginTop:"5px"}}
            />
</Grid>

<Grid item xs={6}>
<TextField
        fullWidth
        select
        label="Ticket Channel"
        name="channel"
        onChange={handleInputChange}
        required="true"
        sx={{marginTop:"5px"}}
      >
        <MenuItem value="">Select Ticket Channel</MenuItem>
        <MenuItem value="Phone Call">Phone Call</MenuItem>
        <MenuItem value="WhatsApp">WhatsApp</MenuItem>
        <MenuItem value="Email">Email</MenuItem>
        <MenuItem value="Facebook">Facebook</MenuItem>
        <MenuItem value="Twitter">Twitter</MenuItem>
        <MenuItem value="Instagram">Instagram</MenuItem>
        <MenuItem value="Chatbot">Chatbot</MenuItem>
      </TextField>
</Grid>

<Grid item xs={6}>
<TextField
        fullWidth
        select
        label="Ticket Status"
        name="status"
        onChange={handleInputChange}
        required="true"
        sx={{marginTop:"5px"}}
      >
        <MenuItem value="">Select Ticket Status</MenuItem>
        <MenuItem value="Open">Open</MenuItem>
        <MenuItem value="In Progress">In Progress</MenuItem>
        <MenuItem value="Resolved">Resolved</MenuItem>
        <MenuItem value="Reopened">Reopened</MenuItem>
        <MenuItem value="Escalated">Escalated</MenuItem>
        <MenuItem value="Awaiting Customer Feedback">Awaiting Customer Feedback</MenuItem>
      </TextField>
</Grid>

<Grid item xs={6}>
<TextField
        fullWidth
        select
        label="Ticket Category"
        name="category"
        onChange={handleInputChange}
        required="true"
        sx={{marginTop:"5px"}}
      >
        <MenuItem value="">Ticket Category</MenuItem>
        <MenuItem value="Open">Open</MenuItem>
        <MenuItem value="In Progress">In Progress</MenuItem>
        <MenuItem value="Resolved">Resolved</MenuItem>
        <MenuItem value="Reopened">Reopened</MenuItem>
        <MenuItem value="Escalated">Escalated</MenuItem>
        <MenuItem value="Awaiting Customer Feedback">Awaiting Customer Feedback</MenuItem>
      </TextField>
</Grid>

<Grid item xs={12}>
<TextField
        fullWidth
        select
        label="Progress Status"
        name="sub_status"
        onChange={handleInputChange}
        required="true"
        sx={{marginTop:"5px"}}
      >
        <MenuItem value="">Select Ticket Progress Status</MenuItem>
        <MenuItem value="Open" selected>Open</MenuItem>
        <MenuItem value="On Hold">On Hold</MenuItem>
        <MenuItem value="In Progress">In Progress</MenuItem>
        <MenuItem value="Done">Done</MenuItem>
      </TextField>
</Grid>

<Grid item xs={12}>
          <TextField
            multiline
            rows={3}
            label="Ticket Description"
            placeholder="Ticket Description"
            variant="outlined"
            fullWidth
            name="description"
            onChange={handleInputChange}
            sx={{marginTop:"5px"}}
          />
        </Grid>

<Grid item xs={12}>
            <Button type="submit" variant="contained" fullWidth color='info' sx={{padding:"10px",marginTop:"10px"}}>Submit Ticket</Button>
            </Grid>

            </Grid>
          </form>
        </div>
        </Box>
      </Modal>




      <Modal
        open={newticketeditopen}
        onClose={() => setNewTickeEditOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={modalStyle}>
        <div className="modal-content">
            <Box sx={{display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h3 id="modal-title">New Ticket</h3>
            <Box display="flex" justifyContent="right">
        <Cancel onClick={() => setNewTickeEditOpen(false)} sx={{cursor:"pointer"}}/>
        </Box>
            </Box>
          
          <form onSubmit={handleNewTicketEditSubmit}>
          {selectedItem && (
          <Grid container spacing={1}>

<Grid item xs={12}>
  <TextField
              name="ticket_id"
              required="true"
              sx={{display:"none!important"}}
              value={selectedItem.ticket_id || ''}
            />
<TextField
        fullWidth
        select
        label="Ticket Priority"
        name="priority"
        onChange={handleInputModChange}
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.priority || ''}
      >
        <MenuItem value="">Select Ticket Priority</MenuItem>
        <MenuItem value="Critical">Critical ( P 1 )</MenuItem>
        <MenuItem value="High">High ( P 2 )</MenuItem>
        <MenuItem value="Medium">Medium ( P 3 )</MenuItem>
        <MenuItem value="Low">Low ( P 4 )</MenuItem>
      </TextField>
</Grid>


          <Grid item xs={6}>
<TextField
              label="Description"
              name="subject"
              onChange={handleInputModChange}
              fullWidth
              variant="outlined"
              required="true"
              sx={{marginTop:"5px"}}
              value={selectedItem.subject || ''}
            />
</Grid>


<Grid item xs={6}>
<TextField
              label="Phone Number"
              name="phone_number"
              onChange={handleInputModChange}
              fullWidth
              variant="outlined"
              required="true"
              sx={{marginTop:"5px"}}
              value={selectedItem.phone_number || ''}
            />
</Grid>

<Grid item xs={6}>
<TextField
              label="(Optional) Alternative Phone Number"
              name="alternative_phone_number"
              onChange={handleInputModChange}
              fullWidth
              variant="outlined"
              sx={{marginTop:"5px"}}
              value={selectedItem.alternative_phone_number || ''}
            />
</Grid>

<Grid item xs={6}>
<TextField
              label="Email"
              name="email"
              onChange={handleInputModChange}
              fullWidth
              variant="outlined"
              sx={{marginTop:"5px"}}
              value={selectedItem.email || ''}
            />
</Grid>

<Grid item xs={6}>
<TextField
        fullWidth
        select
        label="Ticket Channel"
        name="channel"
        onChange={handleInputModChange}
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.channel || ''}
      >
        <MenuItem value="">Select Ticket Channel</MenuItem>
        <MenuItem value="Phone Call">Phone Call</MenuItem>
        <MenuItem value="WhatsApp">WhatsApp</MenuItem>
        <MenuItem value="Email">Email</MenuItem>
        <MenuItem value="Facebook">Facebook</MenuItem>
        <MenuItem value="Twitter">Twitter</MenuItem>
        <MenuItem value="Instagram">Instagram</MenuItem>
        <MenuItem value="Chatbot">Chatbot</MenuItem>
      </TextField>
</Grid>

<Grid item xs={6}>

<TextField
    fullWidth
    select
    label="User"
    name="assigned_to"
    onChange={handleInputModUserChange}
    sx={{marginTop:"5px"}}
    value={selectedItem.assigned_to || ''}>
    <MenuItem value="">Select User</MenuItem>
    { usersData.map((row) => (
    <MenuItem key={row.user_id} value={row.user_id}>
      {row.user_name}
    </MenuItem>
    ))}
  </TextField>

</Grid>
                        

<Grid item xs={6}>
<TextField
        fullWidth
        select
        label="Ticket Status"
        name="status"
        onChange={handleInputModChange}
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.status || ''}
      >
        <MenuItem value="">Select Ticket Status</MenuItem>
        <MenuItem value="Open">Open</MenuItem>
        <MenuItem value="In Progress">In Progress</MenuItem>
        <MenuItem value="Resolved">Resolved</MenuItem>
        <MenuItem value="Reopened">Reopened</MenuItem>
        <MenuItem value="Escalated">Escalated</MenuItem>
        <MenuItem value="Awaiting Customer Feedback">Awaiting Customer Feedback</MenuItem>
      </TextField>
</Grid>

<Grid item xs={6}>
<TextField
        fullWidth
        select
        label="Ticket Category"
        name="category"
        onChange={handleInputModChange}
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.category || ''}
      >
        <MenuItem value="">Ticket Category</MenuItem>
        <MenuItem value="Open">Open</MenuItem>
        <MenuItem value="In Progress">In Progress</MenuItem>
        <MenuItem value="Resolved">Resolved</MenuItem>
        <MenuItem value="Reopened">Reopened</MenuItem>
        <MenuItem value="Escalated">Escalated</MenuItem>
        <MenuItem value="Awaiting Customer Feedback">Awaiting Customer Feedback</MenuItem>
      </TextField>
</Grid>

<Grid item xs={12}>
<TextField
        fullWidth
        select
        label="Progress Status"
        name="sub_status"
        onChange={handleInputModChange}
        required="true"
        sx={{marginTop:"5px"}}
        value={selectedItem.sub_status || ''}
      >
        <MenuItem value="">Select Ticket Progress Status</MenuItem>
        <MenuItem value="Open" selected>Open</MenuItem>
        <MenuItem value="On Hold">On Hold</MenuItem>
        <MenuItem value="In Progress">In Progress</MenuItem>
        <MenuItem value="Done">Done</MenuItem>
      </TextField>
</Grid>

<Grid item xs={12}>
          <TextField
            multiline
            rows={3}
            label="Ticket Description"
            placeholder="Ticket Description"
            variant="outlined"
            fullWidth
            name="description"
            onChange={handleInputModChange}
            sx={{marginTop:"5px"}}
            value={selectedItem.description || ''}
          />
        </Grid>

<Grid item xs={12}>
            <Button type="submit" variant="contained" fullWidth color='info' sx={{padding:"10px",marginTop:"10px"}}>Edit Ticket</Button>
            </Grid>

            </Grid>)}
          </form>
        </div>
        </Box>
      </Modal>






                  <Modal
                      open={openAddTicketCategoryListModal}
                      onClose={handleCloseAddTicketCategoryListModal}
                      aria-labelledby="modal-title"
                      aria-describedby="modal-description"
                  >
                      <Box sx={modalStyle}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                              <h3 id="modal-title">Ticket Category List</h3>
                              <Box display="flex" justifyContent="right">
                                  <Cancel onClick={handleCloseAddTicketCategoryListModal} sx={{ cursor: 'pointer' }} />
                              </Box>
                          </Box>
      <Box sx={{height:'30vh', overflow:'auto'}}>
                  <TableContainer>
                          <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                            {/* Table Head */}
                            <TableHead sx={{bgcolor:'background.table',width:'100%'}}>
                            <TableRow>
                              <TableCell>Ticket Category</TableCell>
                              <TableCell>Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          {ticketCategoryList.map((ticketcategory,i) => (
                              <TableRow key={ticketcategory.id}>
                              <TableCell>{ticketcategory.category}</TableCell>
                              <TableCell><Button  variant="contained" color="error" sx={{ padding: '1px', margin: '5px' }} onClick={() => handleTicketCategotyListDelete(ticketcategory.id)}>
                            <DeleteForever sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} />
                          </Button></TableCell>
                          </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      </Box>
                          <form onSubmit={handleTicketCategoryListSubmit}>
                <Grid container spacing={1}>
      <Grid item xs={12}>
              <TextField
                label="Ticket Category"
                placeholder="Ticket Category"
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                name="category"
                required="true"
                sx={{marginTop:"30px"}}
              />
              </Grid>
      <Grid item xs={12}>
      <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Submit Ticket Category</Button>
      </Grid>
                  </Grid>
                </form>
                      </Box>
                  </Modal>

      </Box>
            </>
    );
};

export default Ticketing;
